"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const core_1 = require("@material-ui/core");
const theme_1 = require("../../styles/theme");
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
const useStyles = core_1.makeStyles(theme => ({
    label: {
        fontFamily: 'Roboto',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontSize: 16,
        fontWeight: 400,
        color: theme_1.colors.black0,
    },
    expandIcon: {
        width: '100%',
        border: `1px solid ${theme_1.colors.greyOfWhite}`,
    },
    icon: {
        color: theme_1.colors.black35,
        padding: 3,
    },
}));
const PageGroupWrapper = props => {
    const { children, controlDefinition } = props;
    const classes = useStyles();
    const StyledAccordionSummary = core_1.withStyles({
        root: {
            alignItems: 'center',
            backgroundColor: theme_1.colors.greyOfWhite,
            minHeight: 0,
            maxHeight: 30,
            padding: '6px 15px',
            '&.Mui-expanded': {
                margin: 0,
                minHeight: 0,
                maxHeight: 30,
                backgroundColor: theme_1.colors.greyOfWhite,
                padding: '6px 15px',
            },
        },
    })(core_1.AccordionSummary);
    const StyledAccordion = core_1.withStyles({
        root: {
            '&.Mui-expanded': {
                height: '100%',
            },
        },
    })(core_1.Accordion);
    const isMoreColumns = props.itemCount > 1 || props.mainColumns === 1 || (props.itemCount === 1 && props.mainColumns > 1);
    return (react_1.default.createElement("div", { style: Object.assign({ position: 'relative' }, (props.mainColumns > 1
            ? {
                marginRight: 2,
                marginBottom: 2,
                height: 'calc(100% - 2px)',
            }
            : {
                marginRight: 12,
                marginBottom: 12,
                height: 'calc(100% - 12px)',
            })) },
        react_1.default.createElement(StyledAccordion, { elevation: 0, defaultExpanded: true, className: classes.expandIcon },
            react_1.default.createElement(StyledAccordionSummary, { expandIcon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: 'fa-solid fa-angle-up', className: classes.icon }) },
                react_1.default.createElement("div", { className: classes.label }, controlDefinition.label)),
            react_1.default.createElement(core_1.AccordionDetails, { style: {
                    padding: isMoreColumns ? '15px 7px 7px 16px' : '15px 0px 0px 16px',
                } },
                react_1.default.createElement("div", { style: {
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                    } }, children)))));
};
exports.default = PageGroupWrapper;
//# sourceMappingURL=PageGroupWrapper.js.map